import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgZoomTo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 25 24" {...props}>
      <path
        d="M5.353 15v4h4.106v2H3.306v-6h2.047zm16.414 0v6h-6.154v-2h4.107v-4h2.047zm-9.23-8c2.267 0 4.102 1.845 4.102 4.122 0 3.092-4.17 6.878-4.103 6.878.067 0-4.102-3.786-4.102-6.878C8.434 8.844 10.268 7 12.536 7zm-.684 2.934a1.378 1.378 0 00.683 2.566c.755 0 1.367-.615 1.368-1.375 0-.49-.26-.945-.684-1.19a1.36 1.36 0 00-1.367-.001zM9.459 3v2H5.353v4H3.306V3h6.153zm12.308 0v6h-2.048V5h-4.107V3h6.154z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('ZoomTo')(SvgZoomTo);
